import { useProductsList } from "modules/products";
import { ItemsTable } from "ui";

import { useProductsColumns } from "../../hooks";
import { StatisticsBlockLayout } from "../../layouts";

import styles from "../../styles/TableStyles.module.scss";

const TopSellingProducts = () => {
  const { products, isLoading } = useProductsList({
    defaultSorting: [{ id: "productsSold", desc: true }],
    defaultTake: 5
  });
  const { columns } = useProductsColumns();

  return (
    <StatisticsBlockLayout
      title="Top-Selling Products"
      navigationPass="/products"
      navigationOptions={{
        state: { sortBy: "productsSold", sortOrder: "desc" }
      }}
    >
      <ItemsTable
        columns={columns}
        data={products ?? []}
        isLoading={isLoading}
        className={styles.statistics__table}
        specificColumnsIndexes={[2]}
        specificColumnsClassName={styles.statistics__table__column_right}
      />
    </StatisticsBlockLayout>
  );
};

export default TopSellingProducts;
